<template>
    <div>
        <named-value :name="title" />

        <spacer />

        <named-value :name="texts.date_payment">
            {{ date | momentDateAndTime }}
        </named-value>
        <named-value :name="texts.fee_number">
            {{ fee }}
        </named-value>
        <named-value :name="texts.fee_date">
            {{ feeDate | momentDateAndTime }}
        </named-value>

        <spacer />

        <template v-if="description">
            <named-value :name="texts.description" variant="stacked">
                {{ description }}
            </named-value>
        </template>
    </div>
</template>

<script>
import NamedValue from "@/components/elements/NamedValue";

export default {
    components: {
        NamedValue
    },
    props: {
        texts: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        date: {
            type: Object,
            required: true
        },
        fee: {
            type: String,
            required: true
        },
        feeDate: {
            type: String,
            required: true
        }
    },
    computed: {
    }
};
</script>
